import axios from "@/plugins/axios";

let url = "/api/v1/me/greenp/offerwall/logs";

export const logs = {
    post(data) {
        return axios.post(url, data).then((result) => result.data);
    },
};

export default logs;
